module.exports = "/_next/static/images/projectEngineering1-b8c34a66d955be97c2306678ccfcbf66.webp";